var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticStyle:{"color":"#DD6625","font-size":"32px"},on:{"click":function($event){return _vm.AbrirJanela()}}},on),[_vm._v("mdi-help-box")])]}}])},[_c('span',[_vm._v("Tutorial")])])}
var staticRenderFns = []

export { render, staticRenderFns }